<div class="engi-statement-modal-wrapper">
  <div class="engi-statement-modal-content">

    <div class="engi-statement-modal__title" *ngIf="modalData?.headerText"
         [innerHTML]="modalData?.headerText | translate">
    </div>

    <div class="engi-statement-modal__body"
       [innerHTML]="modalData?.message">
    </div>

    <div class="bpr_section-btn engi-a-button -primary">
      <a (click)="submitFunc($event)"
         [innerHtml]="modalData?.submitBtnText | translate">
      </a>
    </div>
  </div>
</div>


